// @flow
import { APICore } from './apiCore';

const api = new APICore();

// account
// function ApiGetAllKategoriFasilitas(params: any): any {
//     const baseUrl = '/api/admin/kategorimenu';
//     return api.get(`${baseUrl}`, params);
// }
function ApiGetAllSatuan(params: any): any {
    const baseUrl = '/api/admin/satuan';
    return api.get(`${baseUrl}`, params);
}
// function ApiPostCategoryRoom(params: any): any {
//     const baseUrl = '/api/admin/kategoriroom';
//     return api.create(`${baseUrl}`, params);
// }
function ApiPostSatuan(params: any): any {
    const baseUrl = '/api/admin/satuan';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
// function ApiEditKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.update(`${baseUrl}`, params);
// }
function ApiEditSatuan(params: any, id: any): any {
    const baseUrl = '/api/admin/satuan/' + id;
    return api.update(`${baseUrl}`, params);
}
// function ApiDeleteKategoriRoom(params: any, id: any): any {
//     const baseUrl = '/api/admin/kategoriroom/' + id;
//     return api.delete(`${baseUrl}`, params);
// }

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllSatuan,
    // ApiPostCategoryRoom,
    ApiPostSatuan,
    // ApiEditKategoriRoom,
    ApiEditSatuan,
    // ApiDeleteKategoriRoom,
};
